import { Component, HostListener, OnInit } from '@angular/core';
import { ProductService } from '../../../../shared/services/product.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  constructor(private productService: ProductService) {}
  introductionHeader = 'Even snel online iets bestellen. Makkelijk toch?';
  introductionBody =
    'Maar wat als je bijna niets kunt zien? Ervaar het zelf en probeer' +
    " binnen 60 tellen het juiste product in je winkelwagen te krijgen. Dan maak je kans op het winnen van een heerlijke reep Tony's Chocolonely!";
  introductionButton = 'Ga de uitdaging aan';

  mobile = false;

  ngOnInit() {
    this.checkDevice();
    const body = document.body;
    body.classList.add('start');
    body.classList.add('intro');
    body.classList.remove('game');
  }

  ngOnDestroy() {
    document.body.classList.remove('start');
  }

  @HostListener('window:resize')
  onResize() {
    this.checkDevice();
  }

  private checkDevice() {
    this.mobile = window.innerWidth < 992;
  }
}
